var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaylist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3063 6.23126H2.86133M12.3988 10.0463H2.86133M8.58383 13.8613H2.86133M7.63008 17.6763H2.86133M16.2138 16.2456V8.13876",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8297 18.63C15.1465 18.63 16.2141 17.5625 16.2141 16.2456C16.2141 14.9288 15.1465 13.8613 13.8297 13.8613C12.5128 13.8613 11.4453 14.9288 11.4453 16.2456C11.4453 17.5625 12.5128 18.63 13.8297 18.63Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0289 11.9538C19.0171 11.9538 18.0467 11.5518 17.3313 10.8364C16.6158 10.1209 16.2139 9.15056 16.2139 8.13876",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylist);
export default __webpack_public_path__ + "static/media/playlist.ba5e8c4c2b716fd4700f8612b284d290.svg";
export { ForwardRef as ReactComponent };